import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset-grid"
export default class extends Controller {
  static targets = ["cardholderName", "cardholderNameError", "cardIdentifier", "cardNumber", "cardNumberError", "colorDepth", "expiryDate", "expiryDateError", "form", "javaEnabled", "language", "merchantSessionKey", "securityCode", "securityCodeError", "screenHeight", "screenWidth", "submitButton", "timeZone"]

  connect() {
    this.javaEnabledTarget.value = navigator.javaEnabled();
    this.languageTarget.value = navigator.language;
    this.colorDepthTarget.value = screen.colorDepth;
    this.screenHeightTarget.value = screen.height;
    this.screenWidthTarget.value = screen.width;
    this.timeZoneTarget.value = this.getTimezoneOffsetInMinutes();
  }

  getTimezoneOffsetInMinutes() {
    var date = new Date();
    var offsetInMinutes = date.getTimezoneOffset();
    return offsetInMinutes;
  }

  formatCardNumber() {
    var cardNumber = this.cardNumberTarget.value;
    cardNumber = cardNumber.replace(/[^0-9\s]/g, '');
    cardNumber = cardNumber.replace(/^\s+/, '');
    this.cardNumberTarget.value = cardNumber.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
  }

  submit(event) {
    event.preventDefault();
    const cardIdentifierTarget = this.cardIdentifierTarget;
    const formTarget = this.formTarget;
    const controller = this;
    sagepayOwnForm({ 
      merchantSessionKey: this.merchantSessionKeyTarget.value,
    }).tokeniseCardDetails({ 
      cardDetails: { 
        cardholderName: this.cardholderNameTarget.value,
        cardNumber: this.cardNumberTarget.value.replace(/\s/g, ''),
        expiryDate: this.expiryDateTarget.value,
        securityCode: this.securityCodeTarget.value
      }, 
      onTokenised: function(result) { 
        if (result.success) { 
          cardIdentifierTarget.value = result.cardIdentifier;
          formTarget.submit();
        } else { 
          controller.updateErrorMessagesFromResult(result);
        } 
      } 
    });
  }

  updateErrorMessagesFromResult(json) {
    json.errors.forEach(error => {
      if(error.message == 'The card number length is invalid') {
        this.cardNumberErrorTarget.classList.remove('hidden');
        this.cardNumberErrorTarget.innerText = error.message;
        this.cardNumberTarget.classList.add('error.message');
      } else if(error.message == 'The card number is invalid') {
        this.cardNumberErrorTarget.classList.remove('hidden');
        this.cardNumberErrorTarget.innerText = error.message;
        this.cardNumberTarget.classList.add('error.message');
      } else if(error.message == 'The expiry date is invalid') {
        this.expiryDateErrorTarget.classList.remove('hidden');
        this.expiryDateErrorTarget.innerText = error.message;
        this.expiryDateTarget.classList.add('error.message');
      } else if (error.message == 'The security code length is invalid') {
        this.securityCodeErrorTarget.classList.remove('hidden');
        this.securityCodeErrorTarget.innerText = error.message;
        this.securityCodeTarget.classList.add('error.message');
      } else if (error.message == 'The security code is invalid') {
        this.securityCodeErrorTarget.classList.remove('hidden');
        this.securityCodeErrorTarget.innerText = error.message;
        this.securityCodeTarget.classList.add('error.message');
      } 
    });
  }

  updateSubmitButtonStatus() {
    const cardNumberError = !this.cardNumberErrorTarget.classList.contains('hidden');
    const expiryDateError = !this.expiryDateErrorTarget.classList.contains('hidden');
    const securityCodeError = !this.securityCodeErrorTarget.classList.contains('hidden');
    const cardholderNameBlank = this.cardholderNameTarget.value.length == 0;
    const cardNumberBlank = this.cardNumberTarget.value.length == 0;
    const expiryDateBlank = this.expiryDateTarget.value.length == 0;
    const securityCodeBlank = this.securityCodeTarget.value.length == 0;
    const disabledStatus = cardNumberError || expiryDateError || securityCodeError || cardholderNameBlank || cardNumberBlank || expiryDateBlank || securityCodeBlank;

    this.submitButtonTarget.disabled = disabledStatus;

    if(disabledStatus) {
      this.submitButtonTarget.classList.add('disabled');
    } else {
      this.submitButtonTarget.classList.remove('disabled');
    }
  }

  validateCardholderName() {
    const cardholderName = this.cardholderNameTarget.value;
    this.cardholderNameTarget.value = cardholderName.replace(/[^a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð /\\&]{1,50}$/g, '');
    this.updateSubmitButtonStatus();
  }

  validateCardNumber() {
    this.formatCardNumber();

    const cardNumber = this.cardNumberTarget.value;
    if ((cardNumber.length < 12) || (cardNumber.length > 19) || (cardNumber.match(/\s/g) || []).length > 3) {
      this.cardNumberErrorTarget.classList.remove('hidden');
      this.cardNumberErrorTarget.innerText = 'Please enter a valid card number';
      this.cardNumberTarget.classList.add('error');
    } else {
      this.cardNumberErrorTarget.classList.add('hidden');
      this.cardNumberErrorTarget.innerText = '';
      this.cardNumberTarget.classList.remove('error');
    }
    this.updateSubmitButtonStatus();
  }

  validateExpiryDate() {
    const expiryDate = this.expiryDateTarget.value;
    this.expiryDateTarget.value = expiryDate.replace(/[^0-9]/g, '');

    var month = parseInt(expiryDate.substring(0, 2));
    var year = parseInt(expiryDate.substring(2, 4));
    month -= 1; // because OF COURSE it's zero-indexed
    year += 2000;
    if(month > 11) {
      this.expiryDateErrorTarget.classList.remove('hidden');
      this.expiryDateErrorTarget.innerText = 'Please enter a valid expiry date';
      this.expiryDateTarget.classList.add('error');
      this.updateSubmitButtonStatus();
      return
    }

    const expiry = new Date(year, month, 1);
    const now = new Date();

    if (expiry < now) {
      this.expiryDateErrorTarget.classList.remove('hidden');
      this.expiryDateErrorTarget.innerText = 'Please enter a valid expiry date';
      this.expiryDateTarget.classList.add('error');
    } else {
      this.expiryDateErrorTarget.classList.add('hidden');
      this.expiryDateErrorTarget.innerText = '';
      this.expiryDateTarget.classList.remove('error');
    }
    this.updateSubmitButtonStatus();
  }

  validateSecurityCode() {
    const securityCode = this.securityCodeTarget.value;
    this.securityCodeTarget.value = securityCode.replace(/[^0-9]/g, '');

    if (securityCode.length < 3 || securityCode.length > 4) {
      this.securityCodeErrorTarget.classList.remove('hidden');
      this.securityCodeErrorTarget.innerText = 'Please enter a valid security code';
      this.securityCodeTarget.classList.add('error');
    } else {
      this.securityCodeErrorTarget.classList.add('hidden');
      this.securityCodeErrorTarget.innerText = '';
      this.securityCodeTarget.classList.remove('error');
    }
    this.updateSubmitButtonStatus();
  }
}
